import theme from '@styles/theme';
export default {
  frameBlock: (width = 1) => ({
    width: `${100 / width}%`,
    display: 'table',
    p: '24px',
    borderTop: `1px solid ${theme.rawColors.lightGrey300}`,
    minHeight: '100px'
  }),
  frameImageBlock: {
    position: 'relative',
    maxWidth: ['100%', '100%', '478px', '903px'],
    width: '100%',
    img: {
      width: '100%',
      height: 'auto'
    },
    m: '8px auto 16px',
    display: 'flex',
    justifyContent: 'center',
    zIndex: theme.zIndex.documentUp
  },
  image: (withMargin: boolean) => ({
    position: 'relative',
    objectFit: 'contain',
    m: withMargin ? ['16px 0 32px', '16px 0 32px', '16px 0 40px', '16px 0 40px', '16px 0 48px'] : 0
  })
};